// Removed — onboarding endpoints no longer exist
export function* watchRefresh() {}
